import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type { Route } from 'next';
import type { ReactNode } from 'react';
interface LinkCellProps {
  href: string;
  isSummaryRow?: boolean;
  children: ReactNode;
}
const overlayClasses = 'absolute inset-0 z-10 flex items-center justify-center text-inherit no-underline';
function LinkCell(t0) {
  const $ = _c(5);
  const {
    href,
    isSummaryRow,
    children
  } = t0;
  if (isSummaryRow) {
    let t1;
    if ($[0] !== children) {
      t1 = <span className={overlayClasses}>{children}</span>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = href as Route;
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <Link href={t1} scroll={false} className={overlayClasses}>{children}</Link>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export { LinkCell };